












import Vue, { PropType } from 'vue';
import SearchCard, { CardInfo } from '@/components/SearchCard/SearchCard.vue';
import { AdmissionType } from '@/store/modules/admission/state';

export default Vue.extend({
  components: {
    SearchCard,
  },
  props: {
    admissionTypes: {
      type: Array as PropType<AdmissionType[]>,
      required: true,
    },
    selectedAdmissionType: {
      type: Number,
      default: -1,
    },
  },
  computed: {
    items(): CardInfo[] {
      const items: CardInfo[] = this.admissionTypes.map(admissionType => {
        return {
          key: admissionType.id,
          content: {
            title: admissionType.name,
            description: admissionType.description,
          },
        } as CardInfo;
      });
      return items;
    },
  },
  methods: {
    selectedHandler({ key }: CardInfo) {
      const selectedAdmissionType = this.admissionTypes.find(
        admissionType => admissionType.id === key,
      );
      setTimeout(() => {
        this.$emit('selected', selectedAdmissionType);
      }, 300);
    },
  },
});
